import fetchSingleCampusCartClient from "@/lib/legacyApi/fetchSingleCampusCartClient";
import {atom} from "jotai";
import {CartData} from "../types/CartData";
import makeFetchStoreAtom from "./makeFetchStoreAtom";

const {
	dataAtom,
	isLoadingAtom,
	useRehydrateData: useRehydrateCartAtom,
} = makeFetchStoreAtom(fetchSingleCampusCartClient);

type CartAtomValue = {cart: CartData | null; isLoading: boolean};

// Derived atom that serves the cart data and isLoading state together
const cartAtom = atom<CartAtomValue>((get) => {
	return {
		cart: get(dataAtom),
		isLoading: get(isLoadingAtom),
	};
});

export {cartAtom, useRehydrateCartAtom};
